import { useState } from "react";
import { Phone, X } from "lucide-react";
import { EMERGENCY_TEXT, PHONE_DISPLAY, PHONE_TEL } from "@/data";
import { track } from "@/hooks/useAnalytics";

const KEY = "gpd-emergency-dismissed";

export const EmergencyBanner = () => {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  if (hidden) return null;

  const dismiss = () => {
    sessionStorage.setItem(KEY, "1");
    setHidden(true);
  };

  return (
    <div data-testid="emergency-banner" role="note" className="bg-forest text-cream">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-5 py-2 sm:px-8">
        <p className="flex min-w-0 flex-wrap items-center gap-x-2 font-sans text-xs sm:text-sm">
          <span className="truncate">{EMERGENCY_TEXT}</span>
          <a href={PHONE_TEL} data-testid="emergency-call-link" onClick={() => track("call_click", { location: "emergency-banner" })} className="inline-flex items-center gap-1.5 font-semibold text-cream underline decoration-leaf/70 underline-offset-2 transition-colors hover:decoration-cream">
            <Phone className="h-3.5 w-3.5" /> {PHONE_DISPLAY}
          </a>
        </p>
        <button data-testid="emergency-banner-dismiss" onClick={dismiss} aria-label="Dismiss" className="shrink-0 rounded-full p-1 transition-colors hover:bg-cream/10">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
